import { useId } from 'react'
import { Info } from 'react-feather'
import { UncontrolledTooltip } from 'reactstrap'
import MetricLabel from './MetricLabel'
import ScoreBadge from './ScoreBadge'

const MetricCard = ({
  label,
  value,
  className = '',
  colorType,
  tooltip,
  suffix,
  isSelected = false,
  onClick,
}) => {
  const uniqueId = useId().replace(/:/g, '')
  const tooltipTargetId = `metric-info-${uniqueId}`

  return (
    <div
      onClick={onClick}
      className={`bg-gray-50 p-3 text-center ${className}`}
      style={{
        minWidth: '100px',
        flex: '0 0 auto',
        borderRadius: '8px',
        border: isSelected ? '2px solid #2563eb' : '1px solid #e9ecef',
        backgroundColor: isSelected ? '#f8faff' : undefined,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        boxShadow: isSelected ? '0 0 0 1px #2563eb20' : 'none',
      }}
    >
      <div className="d-flex align-items-center justify-content-center gap-1 text-xs text-gray-500 mb-1">
        <span><MetricLabel label={label} /></span>
        {tooltip && (
          <>
            <Info
              id={tooltipTargetId}
              size={12}
              className="text-muted cursor-pointer"
              style={{ flexShrink: 0 }}
            />
            <UncontrolledTooltip
              placement="top"
              target={tooltipTargetId}
            >
              {tooltip}
            </UncontrolledTooltip>
          </>
        )}
      </div>
      <ScoreBadge score={value} size="normal" colorType={colorType} suffix={suffix} />
    </div>
  )
}

export default MetricCard
